import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isShown: false,
  title: null,
  text: null,
  payload: {},
};

const modals = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    showModalMessage: (state, action) => {
      const { title, text, payload = {} } = action.payload;
      state.isShown = true;
      state.title = title;
      state.text = text;
      state.payload = payload;
    },
    hideModalMessage: () => {
      return initialState;
    },
  },
});

const { actions, reducer } = modals;

export const {
  hideModalMessage, showModalMessage,
} = actions;

export const modalSelectors = {
  state: (state) => state.modals,
}

export default reducer;



// WEBPACK FOOTER //
// ./src/store/modalsSlice.js